import React from "react";
const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;
// The reference poison result modal uses its "front" card set (50x70), not the admin 200x250 one.
const FRONT_CARDS = `${import.meta.env.BASE_URL}img/cards-front`;
const cardImg = (token) => {
  const t = String(token || "").trim();
  return `${FRONT_CARDS}/${!t || t === "0" ? "1" : t}.png`;
};

function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>
          {cards.map((c, i) => (
            <React.Fragment key={i}>
              {" "}
              <div className="casino-result-cards-item">
                <img src={cardImg(c)} alt="" />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for Teenpatti Poison 20-20 (poison20) — same markup as the joker result
 * (.casino-result-content.joker-result) with a "Poison" heading:
 * Poison = card[0], Player A = [1,3,5], Player B = [2,4,6]; trophy before the winner's cards;
 * rdesc "winner#oddeven#color#suit".
 */
export default function Poison20ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const pick = (idx) => idx.map((i) => cards[i]);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5">
      {cards.length > 0 && cards[0] !== "" && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content joker-result">
            <div className="casino-result-content-item text-center">
              <div className="casino-result-cards">
                <div className="d-inline-block">
                  <h4 className="text-playerb">{"\n                  Poison\n                "}</h4>{" "}
                  <div className="casino-result-cards-item">
                    <img src={cardImg(cards[0])} alt="" />
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="casino-result-content-diveder d-none" />{" "}
            <PlayerCards name="Player A" cards={pick([1, 3, 5])} isWinner={win === "1"} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <PlayerCards name="Player B" cards={pick([2, 4, 6])} isWinner={win === "2"} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Odd/Even</div> <div>{desc[1]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Color</div> <div>{desc[2]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Suit</div> <div>{desc[3]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
